// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__hBEgs","cell":"ColumnAccessor_cell__2v-j4","firstCellAccent":"ColumnAccessor_firstCellAccent__2cpMG"};